import { TraitementLine } from '@assets/images/icons';
import './EditionPage.scss';
import { useEtiquetteEditionPageVM } from './useEditionPageVM';
import { Button, Card, Dropdown, Icon } from '@design-system/index';
import { Formik } from 'formik';

export default function EtiquetteEditionPage() {
    const {
        openPrintEtiquettes,
        defaultYears,
        yearsList,
    } = useEtiquetteEditionPageVM();

    return (
        <div className="etiquettes-container">
            <Card 
            headerType='full' 
            showBack 
            backTo="/members-management" 
            headerTitle="Édition étiquettes RTC" 
            headerIcon={<Icon icon={<TraitementLine  />} size={20} color="green-water" />}
            >
                <Formik
                    initialValues={{
                        years: defaultYears
                    }}
                    onSubmit={async (values: { years: number[] }, { resetForm }: { resetForm: () => void }) => {
                        await openPrintEtiquettes(values);
                        resetForm();
                    }}
                >
                    {({ values, handleSubmit, setFieldValue, isSubmitting }) => (
                        <form className="form" onSubmit={handleSubmit}>
                            <div className="form-line-flex">
                                <div className="form-line">
                                    <Dropdown
                                        name="years"
                                        label="Année 1"
                                        value={values.years[0]}
                                        required
                                        onOptionChange={(option) => {
                                            setFieldValue('years', [option.id, values.years[1], values.years[2], values.years[3]]);
                                        }}
                                        options={yearsList.map((year) => ({
                                            label: year.toString(),
                                            id: year
                                        }))}
                                    />
                                </div>
                                <div className="form-line">
                                    <Dropdown
                                        name="years"
                                        label="Année 2"
                                        value={values.years[1]}
                                        onOptionChange={(option) => {
                                            setFieldValue('years', [values.years[0], option.id, values.years[2], values.years[3]]);
                                        }}
                                        options={yearsList.map((year) => ({
                                            label: year.toString(),
                                            id: year
                                        }))}
                                    />
                                </div>
                                <div className="form-line">
                                <Dropdown
                                        name="years"
                                        label="Année 3"
                                        value={values.years[2]}
                                        onOptionChange={(option) => {
                                            setFieldValue('years', [values.years[0], values.years[1], option.id, values.years[3]]);
                                        }}
                                        options={yearsList.map((year) => ({
                                            label: year.toString(),
                                            id: year
                                        }))}
                                    />
                                </div>
                                <div className="form-line">
                                    <Dropdown
                                        name="years"
                                        label="Année 4"
                                        value={values.years[3]}
                                        onOptionChange={(option) => {
                                            setFieldValue('years', [values.years[0], values.years[1], values.years[2], option.id]);
                                        }}
                                        options={yearsList.map((year) => ({
                                            label: year.toString(),
                                            id: year
                                        }))}
                                    />
                                </div>
                            </div>
                                
                            <div className="action-buttons">
                                <Button type="submit" disabled={isSubmitting} variant="primary">
                                    Télécharger les étiquettes
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik> 
            </Card>
        </div>
    );
}
